export enum AppRouteId {
    /**
     * The id for the designer routes
     */
    Designer = "designer",

    /**
     * The id for the reporting routes
     */
    Reporting = "reporting",

    /**
     * The id for the proofs-pages routes
     */
    ProofsPages = "proofs-pages"
}
